import { Component, forwardRef, OnInit, AfterViewInit, ViewChild, OnDestroy } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzUploadChangeParam } from 'ng-zorro-antd/upload';
import { DynamicComponentBase, IDynamicComponentConfig } from '../../../dynamic-component';

@Component({
  selector: 'app-d-uploadfile',
  templateUrl: './d-uploadfile.component.html',
  styles: [],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DUploadfileComponent),
      multi: true
    }
  ]
})
export class DUploadfileComponent extends DynamicComponentBase {
  static KEY = 'd-uploadfile';

  constructor(private msg: NzMessageService) {
    super();
  }

  configChange(config: IDynamicComponentConfig) {}

  handleChange(info: NzUploadChangeParam): void {
    if (info.file.status !== 'uploading') {
      console.log(info.file, info.fileList);
    }
    if (info.file.status === 'done') {
      this.msg.success(`${info.file.name} file uploaded successfully`);
    } else if (info.file.status === 'error') {
      this.msg.error(`${info.file.name} file upload failed.`);
    }
  }
}
